import type { FulfillmentMethod } from '../../product-details';

type NearbyStoresCtaInput = Readonly<{
    fulfilmentMethod: FulfillmentMethod;
    storeId: string | null | undefined;
    availableStock: number | null | undefined;
    altAvailableStock: number | null | undefined;
}>;

export function shouldRenderNearbyStoresCta({
    fulfilmentMethod,
    storeId,
    availableStock,
    altAvailableStock,
}: NearbyStoresCtaInput) {
    const isBopisSelectionValid = !!(storeId && availableStock);

    return Boolean(fulfilmentMethod === 'bopis' && !isBopisSelectionValid && altAvailableStock);
}
